import React from 'react';
import i18n from '../../common/i18n';
import moment from 'moment';

export const LeaderboardTime = ({ start, end }: { start: string | Date; end: string | Date }) => {
    return (
        <div className="pb-10">
            <div className="c-orange text-bold mb-3">{i18n('nui.casino.carousel.in-progress')}</div>
            <div>
                {i18n('nui.common.from')}: {moment(start).format('DD.MM.YYYY HH:mm:ss')}
            </div>
            <div>
                {i18n('nui.common.to')}: {moment(end).format('DD.MM.YYYY HH:mm:ss')}
            </div>
        </div>
    );
};
